<template>
    <div>
       <div class="search_floor">
          <div class="left">
              <div class="title">业务关键字：</div>
              <div class="keyword">活动策划</div>
              <div class="keyword">活动方案</div>
              <div class="keyword">方案定制</div>
              <div class="keyword">案例查找</div>
          </div>
          <div class="right">
              <el-input v-model="search_input"  placeholder="请输入关键字">
                <i slot="prefix" class="el-input__icon"></i>
              </el-input>
          </div>
      </div>
      
    </div>
</template>
      
<script>
export default {
  name: 'search',
  components: {
      
  },
  data () {
    return {
       search_input:''
    }
  },
  mounted () {
      
  },
  methods:{
      
  },
}
</script>

<style lang='scss'>
$zycolor:#CF2C2E;
.search_floor{
  background: #EEEEEE;
  padding:0 140px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  .left{
    display: flex;
  }
  .title{
    
  }
  .keyword{
    color: #A1A1A1;
    cursor: pointer;
    margin-left: 20px;
  }
  .keyword:hover{
    color: $zycolor;
  }
  .right{
    input{
      border:0;
      width: 450px;
      text-align: center;
      border-radius: 30px;
      height: 30px;
      background-image:url('~@/assets/search.png');
      background-repeat:no-repeat;
      background-size:5%;
      background-position:95% center;
      padding-right:55px;
    }
    .el-input__prefix{
          left: unset;
          right: 5px;
          width: 50px;
          cursor: pointer;
    }
  }
}
</style>